const generateTraceId = () => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

const generateSpanId = () => {
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

export const generateTraceParent = (sample = true) => {
  const traceId = generateTraceId();
  const spanId = generateSpanId();
  return {
    traceParent: `00-${traceId}-${spanId}-${sample ? '01' : '00'}`,
    traceId,
    spanId,
  };
};

export const fromTraceParent = (traceParent: string) => {
  const parts = /00-([a-z0-9]{32})-([a-z0-9]{16})-0[01]/.exec(traceParent);
  return {
    traceId: parts?.[1],
    spanId: parts?.[2],
  };
};
